import API from 'services/api';

export const deleteCustomFilter = ({ filterId }: { filterId: string | null }) =>
  API.delete(`/api/users/filters/${filterId}`);
